
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-flashlight-line',
      title: 'Fiber Optik Hizmetleri',
      description: 'Fiber kablo tamiri, sonlandırma, fusion splicing, OTDR test ve acil arıza müdahalesi hizmetleri.',
      features: [
        'Fiber Kablo Tamiri',
        'Fiber Sonlandırma & Fusion Splicing',
        'OTDR Test ve Arıza Tespiti',
        'Bina & Fabrika Fiber Altyapı',
        '7/24 Acil Fiber Servisi',
      ],
      color: 'from-blue-500 to-cyan-500',
      link: '/fiber-hizmetleri',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenlik Sistemleri',
      description: 'IP kamera, alarm, yangın algılama, geçiş kontrol, bariyer ve turnike sistemleri kurulumu.',
      features: [
        'IP Kamera Sistemleri',
        'Hırsız Alarm Sistemleri',
        'Yangın Alarm Sistemleri',
        'Geçiş Kontrol Sistemleri',
        'Bariyer & Turnike Sistemleri',
      ],
      color: 'from-cyan-500 to-blue-500',
      link: '/guvenlik-sistemleri',
    },
  ];

  return (
    <section className="relative py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6 backdrop-blur-sm">
            <i className="ri-service-line text-blue-400"></i>
            <span className="text-sm text-blue-300 font-medium">Hizmetlerimiz</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Profesyonel
            <span className="block mt-2 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              Altyapı Çözümleri
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Fiber optik ve güvenlik sistemleri alanında eksiksiz hizmet yelpazesi
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-blue-500/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/20"
            >
              {/* Glow Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}></div>

              {/* Content */}
              <div className="relative z-10">
                {/* Icon */}
                <div className={`inline-flex items-center justify-center w-16 h-16 mb-6 bg-gradient-to-br ${service.color} rounded-xl group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>

                {/* Title & Description */}
                <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                <p className="text-gray-300 mb-6">{service.description}</p>

                {/* Features List */}
                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className={`ri-checkbox-circle-fill text-lg bg-gradient-to-r ${service.color} bg-clip-text text-transparent mt-1`}></i>
                      <span className="text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Link
                  to={service.link}
                  className={`inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r ${service.color} text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all duration-300 whitespace-nowrap`}
                >
                  Detaylı Bilgi
                  <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
                </Link>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-500/20 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
